import { useEffect, useRef } from 'react';

// 表(カード)の下端を画面の下端にそろえる高さを、表の要素に直接設定する。
// 表の中の行(schoolTableBody)だけがスクロールし、見出しと表の枠は動かない。
// 上にある検索中の表示などの高さが変わると表の位置もずれるので、body の大きさの変化でも計算し直す。
const BOTTOM_GAP = 24;
// 画面がとても低いときに、行が1〜2件しか見えなくならないようにする
const MIN_HEIGHT = 320;

export const useFitTable = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const fit = () => {
      const el = ref.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY;
      const height = `${Math.max(MIN_HEIGHT, Math.floor(window.innerHeight - top - BOTTOM_GAP))}px`;
      if (el.style.height !== height) el.style.height = height;
    };

    fit();
    window.addEventListener('resize', fit);
    const observer = new ResizeObserver(() => requestAnimationFrame(fit));
    observer.observe(document.body);

    return () => {
      window.removeEventListener('resize', fit);
      observer.disconnect();
    };
  }, []);

  return ref;
};
